import { render, staticRenderFns } from "./EditableNumber.vue?vue&type=template&id=ddbf3070&"
import script from "./EditableNumber.vue?vue&type=script&lang=js&"
export * from "./EditableNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ddbf3070')) {
      api.createRecord('ddbf3070', component.options)
    } else {
      api.reload('ddbf3070', component.options)
    }
    module.hot.accept("./EditableNumber.vue?vue&type=template&id=ddbf3070&", function () {
      api.rerender('ddbf3070', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Components/Util/EditableNumber.vue"
export default component.exports